import { getActivityFeedSettingsStore } from '../store/notificationSettingStore';
import { patchActivityFeedSettings } from '../service/patchActivityFeedSettings';
import loadActivityFeed from './loadActivityFeed';
import { toggleActivityFeedSettingPage } from '../actions/toggleActivityFeedSettingPage';

export default function saveActivityFeedSettings() {
    const saveActivityFeedSettingsPromise = patchActivityFeedSettings(
        getActivityFeedSettingsStore()
    );
    saveActivityFeedSettingsPromise.then(loadActivityFeed);
    toggleActivityFeedSettingPage(false);
}
